import { render } from "./SubBundlesView.vue?vue&type=template&id=9130f44e"
import script from "./SubBundlesView.vue?vue&type=script&lang=js"
export * from "./SubBundlesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__